import React from 'react';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import ShownPanelsEnum from '../../../../Enums/ShownPanelsEnum';
import TpClientInvoiceLineItemSearchParams from './TpClientInvoiceLineItemSearchParams';
import TpClientInvoiceLineItemService from '../../../../Services/TpClientInvoiceLineItemService';
import TpClientInvoiceLineItem from '../../../../Domain/TpClientInvoiceLineItem';
import ErrorMessage from '../../../../Elements/ErrorMessage';
import CrudTypesEnum from '../../../../Enums/CrudTypesEnum';
import ButtonColorsEnum from '../../../../Enums/ButtonColorsEnum';
import GeneralEditWizzardBase from '../../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import UpsertTpClientInvoiceLineItemWindowDescription from './UpsertTpClientInvoiceLineItemWindowDescription';
import FigmaButtonRow from '../../../../Elements/FigmaButtonRow';
import ButtonTypeEnum from '../../../../Enums/ButtonTypeEnum';
import IconPositionEnum from '../../../../Enums/IconPositionEnum';
import TpClientInvoiceService from '../../../../Services/TpClientInvoiceService';
import OrderDirectionsEnum from '../../../../Enums/OrderDirectionsEnum';
import RemoveTpClientInvoiceLineItems from '../../../../Domain/RemoveTpClientInvoiceLineItems';
import TpClientInvoiceStatusEnum from '../../../../Enums/ClientInvoiceStatusEnum';
import TpClientInvoiceLineitemUpsertItem from '../../../../Domain/TpClientInvoiceLineItemUpsertItem';

export default class TpClientInvoiceLineItemSubTab extends React.Component {
  static defaultProps = {
    tpClientInvoiceId: 0,
    searchType: '',
  };

  constructor(props) {
    super(props);

    this.state = {
      searchItem: new TpClientInvoiceLineItemSearchParams(),
      shownPanel: ShownPanelsEnum.None,
      itemList: [],
      allItemsInTheSearchSetAreSelected: false,
      numberOfElementsInTheTable: 0,
      clientId: 0,
      currencyId: 0,
      status: null,
      selectedItem: {},
    };
    this.state.searchItem.TpClientInvoiceId = props.tpClientInvoiceId;
    this.state.searchItem.SearchType = props.searchType;
    this.state.searchItem.Type = 'lineItem';

    this.refresh = this.refresh.bind(this);
    this.removeFunction = this.removeFunction.bind(this);
    this.handleExportExcelButtonClick = this.handleExportExcelButtonClick.bind(this);
    TpClientInvoiceLineItem.editFunction = this.editFunction.bind(this);
    TpClientInvoiceLineItem.isDisabled = this.isEditDisabled.bind(this);
  }

  componentDidMount() {
    if (this.props.searchType !== 'prepayment') {
      TpClientInvoiceService.GetSimpleById(this.props.tpClientInvoiceId)
        .then((result) => {
          if (result && result.error) {
            ErrorMessage.SetErrorMessage(result.error);
          } else {
            this.setState({ clientId: result.caspianClientId, currencyId: result.currencyId, status: result.status });
          }
        })
        .catch((error) => ErrorMessage.SetErrorMessage('TPCILIST58', error));
    }
  }

  renderOnePanel = (panelId, content) => (this.state.shownPanel === panelId ? content : null);

  refresh(reload) {
    if (reload) {
      this.setState({ shownPanel: ShownPanelsEnum.None, searchItem: { ...this.state.searchItem } });
      return;
    }
    this.setState({ shownPanel: ShownPanelsEnum.None });
  }

  getAllItemsInTheSearchSetAreSelected() {
    return this.state.allItemsInTheSearchSetAreSelected;
  }

  getSearchParameters() {
    return this.state.searchItem;
  }

  getSelected() {
    return this.state.itemList.filter((u) => u.Selected === true);
  }

  isButtonDisabled() {
    return this.state.status !== TpClientInvoiceStatusEnum.Draft;
  }

  // The row's Edit action outlives finalization, unlike adding and removing line items: the
  // internal line item type is editable on a finalized (and paid) invoice, and the editor locks
  // every other field in that case. A cancelled invoice is not editable at all.
  isEditDisabled(item) {
    // Job line rows are not line item rows, so this editor cannot save them.
    if (item && !item.LineItemTypeId) {
      return true;
    }
    return !this.state.status || this.state.status === TpClientInvoiceStatusEnum.Cancelled;
  }

  isInvoiceFinalized() {
    return !!this.state.status && this.state.status !== TpClientInvoiceStatusEnum.Draft;
  }

  getNumberOfSelectedElements() {
    return this.state.allItemsInTheSearchSetAreSelected
      ? this.state.numberOfElementsInTheTable
      : this.state.itemList.filter((x) => x.Selected === true).length;
  }

  handleExportExcelButtonClick() {
    TpClientInvoiceLineItemService.ExportToExcel(this.state.searchItem).catch(() =>
      ErrorMessage.SetErrorMessage('TPCILIST95')
    );
    ErrorMessage.SetSuccessWithWait(
      'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.'
    );
  }

  removeFunction() {
    const item = new RemoveTpClientInvoiceLineItems();
    item.TpClientInvoiceId = this.props.tpClientInvoiceId;
    item.LineItemListType = 'All';
    item.RemoveItemIds = this.state.itemList.map((item) => item.LineItem);
    item.LineItemSearchItem = this.getSearchParameters();

    TpClientInvoiceService.RemoveLines(item, this.getAllItemsInTheSearchSetAreSelected())
      .then((result) => {
        if (result && result.error) {
          ErrorMessage.SetErrorMessage(result.error);
          ErrorMessage.SetLoading(false);
          this.refresh(false);
          return;
        } else if (result && result.result) {
          ErrorMessage.SetNotification('Partial success. You have got a message with the details.');
        } else {
          ErrorMessage.SetNotification('Line Item(s) Removed.');
        }
        ErrorMessage.SetLoading(false);
        this.refresh(true);
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('TPCILIST124', error);
        ErrorMessage.SetLoading(false);
        this.refresh(false);
      });
    ErrorMessage.SetLoading(true);
  }

  editFunction(id, item) {
    const selectedItem = new TpClientInvoiceLineitemUpsertItem(
      this.props.tpClientInvoiceId,
      this.state.currencyId,
      this.state.clientId,
      item,
      this.isInvoiceFinalized()
    );
    this.setState({ shownPanel: ShownPanelsEnum.EditItem, selectedItem });
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={
              new TpClientInvoiceLineitemUpsertItem(
                this.props.tpClientInvoiceId,
                this.state.currencyId,
                this.state.clientId
              )
            }
            clickOnCancel={() => this.refresh(false)}
            clickOnSave={() => this.refresh(true)}
            windowDescription={UpsertTpClientInvoiceLineItemWindowDescription}
            errorCode={'TPCILIST165'}
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.refresh(false)}
            clickOnSave={() => this.refresh(true)}
            windowDescription={UpsertTpClientInvoiceLineItemWindowDescription}
            errorCode={'TPCILIST169'}
          />
        )}
      </div>
    );
  }

  renderButtonsAndPanels() {
    return (
      <div>
        <FigmaButtonRow
          buttons={[
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Secondary,
              iconPosition: IconPositionEnum.None,
              onClick: () =>
                ErrorMessage.SetApprove(
                  `Remove ${this.getNumberOfSelectedElements()} Line Item(s) from their invoice?`,
                  this.removeFunction
                ),
              label: 'Remove Line Items',
              tooltip: 'Remove Line Items',
              roleKey: 'tpclientinvoices_edit',
              disabled: this.getNumberOfSelectedElements() === 0 || this.isButtonDisabled(),
            },
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Primary,
              iconPosition: IconPositionEnum.Left,
              onClick: () => this.setState({ shownPanel: ShownPanelsEnum.AddNewItem }),
              label: 'New Line Item',
              tooltip: 'New Line Item',
              roleKey: 'tpclientinvoices_edit',
              disabled: this.isButtonDisabled(),
              iconName: 'fa-solid fa-plus-circle',
            },
          ]}
        />
        {this.renderPanels()}
      </div>
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={TpClientInvoiceLineItem}
          serviceFunction={TpClientInvoiceLineItemService.GetListBySearching}
          convertDBItemsFunction={TpClientInvoiceLineItemService.ConvertDBItems}
          orderDirection={OrderDirectionsEnum.Asc}
          orderBy='Name'
          shownPanel={this.state.shownPanel}
          searchItem={this.state.searchItem}
          isExportExcelDisabled={false}
          clickOnExportExcel={this.handleExportExcelButtonClick}
          excelExportRoleKey='tpclientinvoices_view'
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) => {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
          changeOfItemListFunction={(itemList, numberOfElementsInTheTable) =>
            this.setState({ itemList, numberOfElementsInTheTable })
          }
          errorCode='TPCILIST234'
        />
      </div>
    );
  }
}
